export default {
  tags: {
    preferred: 'Preferido',
  },
};
